module.exports = __webpack_public_path__ + "static/dc-nordeste-5-429869100972f556f857575df805cbd3.jpg";